export class AssociaDocentiRequest {
    classeId!: string;
    docentiId!: string;
}